:host {
    display: block;
    width: 100%;
}

.touch-target {
    display: flex;
    align-items: center;
    min-height: 48px;
    width: 100%;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    box-sizing: border-box;
}

.visual-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 48px;
    padding: 0 12px !important;

    border-radius: var(--menu-item-shape, 4px);

    background-color: transparent;

    transition: background-color 0.2s ease-in-out,
        color 0.2s ease-in-out,
        border-radius 0.2s ease-in-out,
        opacity 0.2s ease-in-out,
        outline-width 0.2s ease-in-out;
    ;
}

::slotted([slot=start]) {
    margin-right: var(--item-separation, 8px) !important;
}

::slotted([slot=end]) {
    margin-left: var(--item-separation, 8px) !important;
}

@media (hover: hover) {
    .touch-target:hover .visual-container {
        background-color: rgb(238, 238, 238);
    }
}

.touch-target:focus,
.touch-target:focus-visible {
    outline: none;
}

.touch-target:focus-visible {
    .visual-container {
        outline-style: solid;
        outline-width: 3px;
        outline-color: var(--color-blue-action);
        outline-offset: 0px;
        background-color: rgb(238, 238, 238);
    }
}